@if (role != 'Admin') {
  <div class="dash">
    <div class="kpi kpi-balance">
      <div class="kpi-icon tone-red"><mat-icon>account_balance_wallet</mat-icon></div>
      <div class="kpi-body">
        <span class="kpi-label">الرصيد المتوفر</span>
        <span class="kpi-value">{{ballance}}</span>
      </div>
    </div>
  </div>
}

@if (role == 'Admin') {
  <div class="dash">
    <div class="kpis">
      @for (k of kpis; track k.key) {
        <div class="kpi">
          <div class="kpi-icon" [ngClass]="k.tone"><mat-icon>{{k.icon}}</mat-icon></div>
          <div class="kpi-body">
            <span class="kpi-label">{{k.label | translate}}</span>
            <span class="kpi-value">{{kpiValue(k.key)}}</span>
          </div>
        </div>
      }
    </div>

    @if (overview) {
      <div class="charts">
        <!-- الاتجاه اليومي: مبلغ واحد عبر الزمن -> hue واحد -->
        <div class="panel">
          <div class="panel-head">
            <mat-icon>show_chart</mat-icon>
            <h3>{{'chartDailyTrend' | translate}}</h3>
          </div>
          <div class="columns">
            @for (d of overview.dailyTrend; track d) {
              <div class="col">
                <span class="col-value" [style.visibility]="d.amount > 0 ? 'visible' : 'hidden'">{{d.amount}}</span>
                <div class="col-bar" [style.height.%]="barHeight(d.amount, overview.dailyTrend, 'amount')"
                  [style.background]="trendColor"
                  [attr.title]="d.date + ' — ' + d.amount + ' (' + d.count + ' عملية)'"></div>
                <span class="col-label">{{d.date}}</span>
              </div>
            }
          </div>
        </div>

        <!-- توزيع العمليات حسب النوع: أربع فئات هوية -> لون لكل فئة -->
        <div class="panel">
          <div class="panel-head">
            <mat-icon>donut_small</mat-icon>
            <h3>{{'chartOperationsByType' | translate}}</h3>
            <span class="panel-sub">{{'last30Days' | translate}}</span>
          </div>
          @for (t of overview.operationsByType; track t; let i = $index) {
            <div class="hbar">
              <div class="hbar-top">
                <span>{{translateLabel(t.label) | translate}}</span>
                <b>{{t.count}}</b>
              </div>
              <div class="hbar-track">
                <div class="hbar-fill" [style.width.%]="barHeight(t.count, overview.operationsByType, 'count')"
                  [style.background]="typeColors[i % typeColors.length]"></div>
              </div>
            </div>
          }
        </div>

        <!-- المستخدمون حسب الفئة: مقارنة أعداد -> hue واحد -->
        <div class="panel">
          <div class="panel-head">
            <mat-icon>groups</mat-icon>
            <h3>{{'chartUsersByCategory' | translate}}</h3>
          </div>
          @for (c of overview.usersByCategory; track c) {
            <div class="hbar">
              <div class="hbar-top">
                <span>{{translateLabel(c.label) | translate}}</span>
                <b>{{c.count}}</b>
              </div>
              <div class="hbar-track">
                <div class="hbar-fill" [style.width.%]="barHeight(c.count, overview.usersByCategory, 'count')"
                  [style.background]="categoryColor"></div>
              </div>
            </div>
          }
        </div>

        <!-- نمو المستخدمين الشهري -->
        <div class="panel">
          <div class="panel-head">
            <mat-icon>trending_up</mat-icon>
            <h3>{{'chartMonthlyGrowth' | translate}}</h3>
          </div>
          <div class="columns">
            @for (m of overview.monthlyUserGrowth; track m) {
              <div class="col">
                <span class="col-value" [style.visibility]="m.count > 0 ? 'visible' : 'hidden'">{{m.count}}</span>
                <div class="col-bar" [style.height.%]="barHeight(m.count, overview.monthlyUserGrowth, 'count')"
                  [style.background]="growthColor"
                  [attr.title]="m.label + ' — ' + m.count + ' مستخدم جديد'"></div>
                <span class="col-label">{{m.label}}</span>
              </div>
            }
          </div>
        </div>

        <!-- العمولات خلال آخر ٧ أيام -->
        <div class="panel">
          <div class="panel-head">
            <mat-icon>savings</mat-icon>
            <h3>{{'chartWeeklyCommissions' | translate}}</h3>
          </div>
          <div class="columns">
            @for (d of overview.weeklyCommissionsTrend; track d) {
              <div class="col">
                <span class="col-value" [style.visibility]="d.amount > 0 ? 'visible' : 'hidden'">{{d.amount}}</span>
                <div class="col-bar" [style.height.%]="barHeight(d.amount, overview.weeklyCommissionsTrend, 'amount')"
                  [style.background]="commissionsColor"
                  [attr.title]="d.date + ' — ' + d.amount"></div>
                <span class="col-label">{{d.date}}</span>
              </div>
            }
          </div>
        </div>

        <!-- أعلى ٥ مستخدمين رصيداً -->
        <div class="panel">
          <div class="panel-head">
            <mat-icon>emoji_events</mat-icon>
            <h3>{{'chartTopBalances' | translate}}</h3>
          </div>
          @for (u of overview.topUsersByBalance; track u) {
            <div class="hbar">
              <div class="hbar-top">
                <span>{{u.label}}</span>
                <b>{{u.amount}}</b>
              </div>
              <div class="hbar-track">
                <div class="hbar-fill" [style.width.%]="barHeight(u.amount, overview.topUsersByBalance, 'amount')"
                  [style.background]="balanceColor"></div>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (overview?.latestRejectedOperations?.length > 0) {
      <div class="panel panel-table">
        <div class="panel-head">
          <mat-icon>block</mat-icon>
          <h3>{{'kpiLatestRejected' | translate}}</h3>
        </div>
        <div class="table-wrap">
          <table>
            <tr>
              <th>{{'id' | translate}}</th>
              <th>{{'fullName' | translate}}</th>
              <th>{{'rejectReason' | translate}}</th>
              <th>{{'dateTime' | translate}}</th>
            </tr>
            @for (row of overview.latestRejectedOperations; track row) {
              <tr>
                <td>{{row.id}}</td>
                <td>{{row.userFullName}}</td>
                <td class="reason">{{row.rejectReason}}</td>
                <td>{{row.date}}</td>
              </tr>
            }
          </table>
        </div>
      </div>
    }
  </div>
}

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>
